import api from '@/lib/axios';
import type { ApiResponse, HotelProperty, HotelPropertyPayload } from '@/types';

export const hotelPropertiesService = {
  async list(): Promise<HotelProperty[]> {
    const { data } = await api.get<ApiResponse<HotelProperty[]>>('/v1/propriedades-hoteleiras');
    return data.data;
  },

  async create(payload: HotelPropertyPayload): Promise<HotelProperty> {
    const { data } = await api.post<ApiResponse<HotelProperty>>('/v1/propriedades-hoteleiras', payload);
    return data.data;
  },

  async update(id: number, payload: HotelPropertyPayload): Promise<HotelProperty> {
    const { data } = await api.put<ApiResponse<HotelProperty>>(`/v1/propriedades-hoteleiras/${id}`, payload);
    return data.data;
  },

  async remove(id: number): Promise<void> {
    await api.delete(`/v1/propriedades-hoteleiras/${id}`);
  },
};
